import React from 'react'
import { RichText, RichTextBlock } from 'prismic-reactjs'
import Skeleton from 'atoms/feedback/Skeleton'

export type RichTitleProps = {
  content: RichTextBlock[] | null
}

export default function RichTitle ({ content }: RichTitleProps) {
  return (
    <>
      { content ? (RichText.render(content)) : (<Skeleton height="3rem"/>)}
    </>
  )
}
